import {
    ChangeDetectorRef,
    Component, Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {NgClass, NgForOf, NgIf, UpperCasePipe} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {FuseCardComponent} from "../../../../@fuse/components/card";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatDivider} from "@angular/material/divider";
import {MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {TranslocoPipe} from "@ngneat/transloco";
import {DateTimeService} from "../../../core/services/date.time.service";
import {UserService} from "../../../core/services/user.service";
import {AuditType} from "./audit.types";

@Component({
    selector     : 'audit-component',
    templateUrl  : './audit.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [
        MatIcon,
        NgIf,
        MatIconButton,
        TranslocoPipe
    ],
})
export class AuditComponent implements OnChanges, OnInit, OnDestroy
{
    @Input() auditData:AuditType;
    expanded: boolean = false;


    constructor(
        private _dateTimeService: DateTimeService,
    ) {}


    ngOnChanges(changes: SimpleChanges) {
        if(changes.auditData.currentValue){
            this.auditData = changes.auditData.currentValue;
            if(!this.auditData.createdOnStr && this.auditData?.createdOn) {
                if(this.auditData?.createdOn){
                    const createdDate: Date = this._dateTimeService.getDateAndTimeFromBEInDateObject(this.auditData.createdOn);
                    this.auditData.createdOnStr = this._dateTimeService.getFormatedDate(createdDate);
                }
                if(this.auditData?.updatedOn){
                    const updatedDate: Date = this._dateTimeService.getDateAndTimeFromBEInDateObject(this.auditData.updatedOn);
                    this.auditData.updatedOnStr = this._dateTimeService.getFormatedDate(updatedDate);
                }
            }
        }
    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {
    }

}
